export default __webpack_public_path__ + "static/media/crying-pepe.628b9b25.gif";